import { CellEllipsisProps } from "../table.types";
import DateTimeHelper from "shared/utils/dateTimeHelper";

export default function CellTimeSlot(props: CellEllipsisProps) {
  return (
    <div className="td_ellipsis" title={props.value}>
      <span>
        {DateTimeHelper.formatDate({
          startDate: props.row.original.timeFrom,
          option: { showWeekDay: true, showYear: true }
        })}
      </span>
      <br />
      <span>
        {DateTimeHelper.formatDate({ startDate: props.row.original.timeFrom, option: { showOnlyTime: true } })}
      </span>
    </div>
  );
}
